import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function SEOResourcesSection() {
  const links = [{
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-Questions-and-Answers',
    text: 'Laser Therapy Q&A'
  }, {
    url: 'https://www.paragonchiropractic.com/What-Conditions-Can-Be-Treated-with-Laser-Therapy',
    text: 'Conditions Treated'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Arthritis',
    text: 'Laser Therapy for Arthritis'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Bursitis',
    text: 'Laser Therapy for Bursitis'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Carpal-Tunnel',
    text: 'Laser Therapy for Carpal Tunnel'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Ligament-Injuries',
    text: 'Laser Therapy for Ligament Injuries'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Muscle-Strains-Sprains',
    text: 'Laser Therapy for Muscle Strains & Sprains'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Myofascial-Pain-Syndrome',
    text: 'Laser Therapy for Myofascial Pain Syndrome'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Tendonitis-and-Tendon-Injuries',
    text: 'Laser Therapy for Tendonitis & Tendon Injuries'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Scar-Tissue-and-Fibrosis',
    text: 'Laser Therapy for Scar Tissue & Fibrosis'
  }, {
    url: 'https://www.paragonchiropractic.com/Laser-Therapy-for-Plantar-Fasciitis',
    text: 'Laser Therapy for Plantar Fasciitis'
  }];
  return <section className="py-12 md:py-16 bg-brand-gray-light border-t border-gray-200" data-id="element-246">
      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <h3 className="text-xs md:text-sm font-black text-brand-navy uppercase tracking-widest mb-6 text-center" data-id="element-248">
          Laser Therapy Resources
        </h3>
        <div className="flex flex-wrap justify-center gap-2" data-id="element-249">
          {links.map((link, idx) => <a key={idx} href={link.url} className="inline-flex items-center gap-1.5 bg-white border border-gray-300 hover:border-brand-teal hover:text-brand-teal-dark text-gray-700 text-xs md:text-sm font-semibold px-3.5 py-2 rounded-lg transition-colors shadow-sm" data-id="element-250">
              <ExternalLinkIcon className="w-3.5 h-3.5" data-id="element-251" />
              {link.text}
            </a>)}
        </div>
      </div>
    </section>;
}